module.exports = __webpack_public_path__ + "img/Brand.dd57bdd4.png";